import React from 'react'

const LoadingIndicator = (): React.ReactElement => {
  return (
    <div className="mt-5 space-y-3 px-4">
      <div className="skeleton skeleton-text" style={{ width: '70%' }} />
      <div className="skeleton skeleton-text" style={{ width: '50%' }} />
      <div className="skeleton skeleton-card" />
      <div className="skeleton skeleton-card" />
    </div>
  )
}

export default LoadingIndicator
